import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  ${(props) => {
    return props.paper
      ? {
          background: '#ffffff',
          'box-shadow': `0px 2px 4px 1px rgba(165, 178, 200, 0.1),
    0px 1px 6px rgba(165, 178, 200, 0.2)`,
          'border-radius': '4px',
        }
      : {};
  }}
  display:flex;
  flex-direction: ${(props) => (props.layout === 'vertical' ? 'column' : 'row')};
`;

const Blank = ({ paper = false, layout = 'vertical', ...props }) => {
  return <StyledContainer paper={paper} layout="vertical" {...props} />;
};

const Layout = {
  Blank,
};
export default Layout;
